import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL || "",
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("access");
      window.location.href = "/auth/sign-in";
    }
    return Promise.reject(error);
  }
);

const commonApi = async (httpMethod, url, reqBody, reqHeader = {}) => {
  const reqConfig = {
    method: httpMethod,
    url,
    data: reqBody,
    headers: reqHeader,
  };

  try {
    const response = await api(reqConfig);
    return response;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    return { error: true, message: error.message };
  }
};

export default commonApi;